import { render, staticRenderFns } from "./VideosForm.vue?vue&type=template&id=60b43c52&"
import script from "./VideosForm.vue?vue&type=script&lang=js&"
export * from "./VideosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports